export default __webpack_public_path__ + "static/media/job_offer12_l.83d3f374.jpg";